var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.transfer},[_c('a',{attrs:{"title":"乐游游推荐","href":"https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkxODMwODU4Ng==&scene=124#wechat_redirect"}})])}
var staticRenderFns = []

export { render, staticRenderFns }